var map = {
	"./bg.png": "/B4r",
	"./en/ap.png": "CLYJ",
	"./en/gp.png": "uwLo",
	"./en/pay-en-1.png": "Ug3R",
	"./en/pay-en.png": "UaZd",
	"./en/pre-steam.png": "dW+5",
	"./en/pre-window.png": "AOQm",
	"./en/pre/pre-window.png": "EY1A",
	"./en/pre/slogan-1.png": "hT8/",
	"./en/pre/slogan.png": "JFl1",
	"./en/slogan.png": "mvGP",
	"./pc_1.png": "AiyV",
	"./pc_2.png": "5okQ",
	"./pc_3.png": "fDvo",
	"./play-btn.png": "te2o",
	"./play-btn=-.png": "Axqx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bQq/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1 ^\.\/.*\.png$
// module id = bQq/
// module chunks = 0